<script lang="ts">
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Design system componnets
	import { Button, Input, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);
	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	let transition = settings[device.category + 's']
		? settings[device.category + 's'][device.channel].transition
		: undefined;

	const min = 0,
		max = 5000;
	let loading = false;

	let value = transition !== undefined ? transition : settings.transition;
	let cache = value;

	let localIp = get_local_ip(id);

	const setTransitionTime = async () => {
		if (cache !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(
					device,
					`${localIp}/settings/${transition ? device.category + `/${device.channel}` : 'settings/'}`,
					'post',
					{
						transition: value,
					},
				);
			} else {
				res = await postReq(`/device/${device.category}/settings/transition_time`, {
					id: id,
					time: value,
					channel: device.channel,
				});
			}

			if (res.isok) {
				transition !== undefined
					? (settings[device.category + 's'][device.channel].transition = value)
					: (settings.transition = value);
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title:
						$format('transition_time_set_scc_toast', { values: { value } }) ||
						`Transition time was changed to ${value}ms.`,
				});
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Input
	class="mb-s"
	size="m"
	bind:value
	type={'number'}
	{min}
	{max}
	info={$format('set_transition_time', {
		values: { min, max },
		default: 'Set transition time between {min} and {max} miliseconds.',
	})}
	on:enter={setTransitionTime}
	id="input-uor2qr0"
	aria-label={$format('set_transition_time', {
		values: { min, max },
		default: 'Set transition time between {min} and {max} miliseconds.',
	})}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setTransitionTime}
	>{$format('button_save')}</Button
>
